import { Link, rootRouteId, useMatch, useRouter } from '@tanstack/react-router'
import { AlertTriangle, ArrowLeft, RefreshCw } from 'lucide-react'
import { Button } from './ui/button'
import type { ErrorComponentProps } from '@tanstack/react-router'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'

export function DefaultCatchBoundary({ error }: ErrorComponentProps) {
  const router = useRouter()
  const isRoot = useMatch({
    strict: false,
    select: (state) => state.id === rootRouteId,
  })

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto w-16 h-16 bg-destructive/10 rounded-full flex items-center justify-center mb-4">
            <AlertTriangle className="w-8 h-8 text-destructive" />
          </div>

          <CardTitle className="text-2xl">Something Went Wrong</CardTitle>
          {error && <p className="text-destructive">{error.message}</p>}

          <CardDescription>
            We encountered an unexpected error. You can try refreshing the page
            or go back.
          </CardDescription>
        </CardHeader>

        <CardContent className="space-y-4">
          <div className="flex flex-col gap-2">
            <div className="grid grid-cols-2">
              {isRoot ? (
                <Link to="/">
                  <Button variant="outline" className="flex-1 w-full">
                    <ArrowLeft className="w-4 h-4 mr-2" />
                    Home
                  </Button>
                </Link>
              ) : (
                <Link
                  to="/"
                  onClick={(e) => {
                    e.preventDefault()
                    window.history.back()
                  }}
                >
                  <Button variant="outline" className="flex-1 w-full">
                    <ArrowLeft className="w-4 h-4 mr-2" />
                    Go Back
                  </Button>
                </Link>
              )}

              <Button
                variant="outline"
                onClick={() => router.invalidate()}
                className="flex-1"
              >
                <RefreshCw className="w-4 h-4 mr-2" />
                Refresh
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
